import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import FrenquentlyAsked from './Sections/FrenquentlyAsked'
import HowItWorks from './Sections/HowItWorks'
import Inspire from './Sections/Inspire'
import Intro from './Sections/Intro'
import MoreAboutUs from './Sections/MoreAboutUs'
import PackagingStyle from './Sections/PackagingStyle'
import QuoteRequest from './Sections/QuoteRequest'
import SuccesCase from './Sections/SuccessCase'

const Home = () => {
  return (
    <>
      <Header />
      <main className='flex flex-col justify-center items-center'>
        <Intro />
        <PackagingStyle />
        <HowItWorks />
        <SuccesCase />
        <Inspire />
        <MoreAboutUs />
        <FrenquentlyAsked />
        <QuoteRequest />
      </main>
      <Footer />
    </>
  )
}

export default Home
